import { Badge as AntBadge } from "antd";
import { BadgeProps as Props } from "antd/lib/badge";
import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";

type StyleProps = {
  readonly className?: string;
  readonly badgeColor: Color.Color;
  readonly textColor?: Color.Color;
};

const Style = styled.span<StyleProps>`
  & ${({ className }) => (className ? `.${className}` : "")} .ant-badge-count {
    background-color: ${({ badgeColor }) => `${badgeColor}`};
    color: ${({ textColor }) => (textColor ? textColor : Color.white())};
  }
  & .ant-badge {
    padding: 0.5em;
  }
`;

export const Component: Component<{
  readonly count: Props["count"];
  readonly overflowCount?: Props["overflowCount"];
  readonly className?: Props["className"];
  readonly badgeColor?: Color.Color;
  readonly textColor?: Color.Color;
}> = ({ count, overflowCount, className, badgeColor, textColor }) => {
  const renderBadge = () => (
    <AntBadge
      count={count}
      overflowCount={overflowCount}
      className={className}
    />
  );

  if (badgeColor) {
    return (
      <Style
        className={className}
        badgeColor={badgeColor}
        textColor={textColor}
      >
        {renderBadge()}
      </Style>
    );
  }

  return renderBadge();
};
